import { render, staticRenderFns } from "./DashboardRecentSites.vue?vue&type=template&id=3c143315&"
import script from "./DashboardRecentSites.vue?vue&type=script&lang=js&"
export * from "./DashboardRecentSites.vue?vue&type=script&lang=js&"
import style0 from "./DashboardRecentSites.vue?vue&type=style&index=0&id=3c143315&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports